import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { WatchZoneProvider } from './contexts/WatchZoneContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { configureAuth } from './config/auth';
import 'leaflet/dist/leaflet.css';
import './styles/App.css';

// Configure AWS Amplify for Cognito auth
configureAuth();

// Register service worker for PWA support (offline fallback + push notifications)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <WatchZoneProvider>
            <App />
          </WatchZoneProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
